import { render, staticRenderFns } from "./JobInformation.vue?vue&type=template&id=78bd0ab8&scoped=true"
import script from "./JobInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./JobInformation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobInformation.vue?vue&type=style&index=0&id=78bd0ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd0ab8",
  null
  
)

export default component.exports